import React from "react";

export default function DialogCheck({
  icon,
  iconColor,
  title,
  message,
  buttonTitle,
  isCancelButton,
  onSubmit,
  onClose,
}) {
  return (
    <div className="rounded-3 overflow-hidden" style={{ minWidth: "380px" }}>
      {/* Header */}
      <div
        className="px-4 py-3 d-flex align-items-center gap-3"
        style={{
          background: `linear-gradient(135deg, ${iconColor} 0%, ${iconColor}dd 100%)`,
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-circle"
          style={{
            width: "42px",
            height: "42px",
            background: "rgba(255,255,255,0.2)",
          }}
        >
          <i
            className={icon || "bi bi-question-octagon-fill"}
            style={{ fontSize: "1.2rem", color: "#fff" }}
          />
        </div>
        <div className="flex-grow-1">
          <h6
            className="mb-0 text-white fw-bold"
            style={{ fontSize: "0.95rem" }}
          >
            {title}
          </h6>
        </div>
        <button
          className="btn-close btn-close-white"
          style={{ opacity: 0.8 }}
          aria-label="Close"
          onClick={onClose}
        />
      </div>

      {/* Body */}
      <div className="px-4 py-4" style={{ background: "#fff" }}>
        <div className="d-flex align-items-start gap-3">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
            style={{
              width: "40px",
              height: "40px",
              background: `${iconColor}18`,
            }}
          >
            <i
              className="bi bi-info-circle-fill"
              style={{ fontSize: "1.1rem", color: iconColor }}
            />
          </div>
          <p
            className="mb-0"
            style={{ fontSize: "0.9rem", color: "#4b5563", lineHeight: "1.5" }}
          >
            {message ?? ""}
          </p>
        </div>
      </div>

      {/* Footer */}
      <div
        className="px-4 py-3 d-flex justify-content-end gap-2"
        style={{ background: "#f9fafb", borderTop: "1px solid #f0f0f0" }}
      >
        {isCancelButton && (
          <button
            onClick={onClose}
            className="btn rounded-3 px-4 py-2 fw-semibold"
            style={{
              backgroundColor: "#f3f4f6",
              color: "#374151",
              border: "1px solid #e5e7eb",
              fontSize: "0.85rem",
              transition: "all 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#e5e7eb";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#f3f4f6";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            Cancel
          </button>
        )}
        <button
          onClick={onSubmit}
          className="btn text-white rounded-3 px-4 py-2 fw-semibold"
          style={{
            backgroundColor: iconColor,
            border: "none",
            fontSize: "0.85rem",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = `0 4px 12px ${iconColor}50`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
        >
          {buttonTitle || "Go to Fully Receive"}
        </button>
      </div>
    </div>
  );
}
